export default {
	'THEME': 'missmiu',
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_ORDERBOX_DELIVERY": true,
	"FEATURE_ORDERBOX_TAKEAWAY": true,
}
